import Header from "../components/header";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import PharmaciesFilter from "../components/pharmaciesFilterBox";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../redux";
import { loadPharmacies } from "../redux/reducer/pharmaciesReducer";
import PharmaciesTable from "../components/pharmaciesTable";


const PharmacyList = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user } = useSelector((state: any) => state.login);
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(loadPharmacies(1));
  }, [])

  return (
    <>

      <Header active={true} titleLogOut={user?.username} />
      <PharmaciesFilter />
      <PharmaciesTable />
    </>
  );
}

export default PharmacyList;
